import axios from "axios";

import getTenant from "./getTenant";

export default async function getAdminApiBaseUrl(): Promise<string> {
  const tenant = getTenant();
  const environment = process.env.REACT_APP_ENV_TYPE || "local";

  try {
    const response = await axios.get(
      `/tenant-metadata/${environment}/${tenant}.json`
    );
    if (response.data?.backendUrl) {
      return response.data.backendUrl;
    }
  } catch (e: any) {
    if (e.response && e.response.status === 404) {
      // there is no backend URL override for this tenant -- do nothing
    } else {
      throw e;
    }
  }

  const response = await axios.get(
    `/tenant-metadata/${environment}/shared.json`
  );
  return response.data.backendUrl;
}
